import { useState, useEffect } from 'react'
import { fetchWithAuth } from '../utils/api'


interface StatsData {
  activeTasks: number
  recentWildlife: number
  totalAssets: number
  recentActivity: number
}

function QuickStats(): JSX.Element {
  const [stats, setStats] = useState<StatsData>({
    activeTasks: 0,
    recentWildlife: 0,
    totalAssets: 0,
    recentActivity: 0
  })
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    fetchStats()
  }, [])

  const fetchStats = async () => {
    try {
      setLoading(true)
      
      const [tasksResponse, wildlifeResponse, assetsResponse] = await Promise.all([
        fetchWithAuth('/api/tasks?status=active').catch(() => null),
        fetchWithAuth('/api/assets?type=wild_animal').catch(() => null),
        fetchWithAuth('/api/assets').catch(() => null)
      ])

      let activeTasks = 0
      let recentWildlife = 0
      let totalAssets = 0

      if (tasksResponse && tasksResponse.ok) {
        const tasksData = await tasksResponse.json()
        activeTasks = tasksData.tasks?.length || 0
      }

      if (wildlifeResponse && wildlifeResponse.ok) {
        const wildlifeData = await wildlifeResponse.json()
        const wildlife = wildlifeData.assets || []
        totalAssets += wildlife.length
        
        // Count wildlife from last 24 hours
        const oneDayAgo = new Date()
        oneDayAgo.setHours(oneDayAgo.getHours() - 24)
        recentWildlife = wildlife.filter((asset: any) => 
          new Date(asset.time_started) > oneDayAgo
        ).length
      }

      if (assetsResponse && assetsResponse.ok) {
        const assetsData = await assetsResponse.json()
        totalAssets = assetsData.assets?.length || 0
      }

      const recentActivity = activeTasks + recentWildlife

      setStats({
        activeTasks,
        recentWildlife,
        totalAssets,
        recentActivity
      })
    } catch (error) {
      console.error('Failed to fetch stats:', error)
    } finally {
      setLoading(false)
    }
  }

  if (loading) {
    return (
      <div className="quick-stats">
        <div className="quick-stats__loading">
          <div className="loading-spinner">Loading stats...</div>
        </div>
      </div>
    )
  }

  return (
    <div className="quick-stats">
      <div className="quick-stats__grid">
        <div className="stat-item stat-item--tasks">
          <div className="stat-item__icon">📋</div>
          <div className="stat-item__value">{stats.activeTasks}</div>
          <div className="stat-item__label">Active Tasks</div>
        </div>
        
        <div className="stat-item stat-item--wildlife">
          <div className="stat-item__icon">🦌</div>
          <div className="stat-item__value">{stats.recentWildlife}</div>
          <div className="stat-item__label">Recent Wildlife</div>
        </div>
        
        <div className="stat-item stat-item--assets">
          <div className="stat-item__icon">📦</div>
          <div className="stat-item__value">{stats.totalAssets}</div>
          <div className="stat-item__label">Total Assets</div>
        </div>
        
        <div className="stat-item stat-item--activity">
          <div className="stat-item__icon">⚡</div>
          <div className="stat-item__value">{stats.recentActivity}</div>
          <div className="stat-item__label">Recent Activity</div>
        </div>
      </div>
    </div>
  )
}

export default QuickStats